export enum EUserOnboardingPercentage {
    StepOne = 25,
    StepTwo = 50,
    StepThree = 75,
}
